<div class="summary-panel">

  <div class="summary-panel__icon" *ngIf="hasIcon">
    <ng-content select="summary-panel-icon"></ng-content>
  </div>

  <div class="summary-panel__content">
    <ng-content select="summary-panel-content"></ng-content>
  </div>

  <div class="summary-panel__action" *ngIf="hasAction">
    <ng-content select="summary-panel-action"></ng-content>
  </div>

</div>
